import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';

@Injectable({
    providedIn: 'root',
})
export class IsAdminGuard implements CanActivate {
    constructor(private accountService: AccountService, private router: Router) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this.accountService.userHasRole('admin')) {
            this.router.navigateByUrl('/', {
                state: { hasState: true, type: 'warning', message: 'You don’t have permission to access this resource' },
            });
            return true;
        } else {
            return true;
        }
    }
}
